// Initials colours, as token class pairs (soft wash + full-strength letter).
// Same order as the Swift apps' `Color.memberAvatar(for:)` palette.
const AVATAR_COLORS = [
  'bg-avatar-blue/20 text-avatar-blue',
  'bg-avatar-purple/20 text-avatar-purple',
  'bg-avatar-pink/20 text-avatar-pink',
  'bg-avatar-orange/20 text-avatar-orange',
  'bg-avatar-green/20 text-avatar-green',
  'bg-avatar-teal/20 text-avatar-teal',
  'bg-avatar-indigo/20 text-avatar-indigo',
];

// FNV-1a 64-bit over the key's UTF-8 bytes — the hash the Swift apps use, so
// a user gets the same colour on web, macOS and iOS.
const FNV_OFFSET = BigInt('0xcbf29ce484222325');
const FNV_PRIME = BigInt('0x100000001b3');

export const avatarColorClass = (key: string): string => {
  let hash = FNV_OFFSET;
  for (const byte of new TextEncoder().encode(key)) {
    hash = BigInt.asUintN(64, (hash ^ BigInt(byte)) * FNV_PRIME);
  }
  return AVATAR_COLORS[Number(hash % BigInt(AVATAR_COLORS.length))];
};

// Up to two initials from a display name.
export const initialsOf = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('') || '?';
